<template>
	<div>
		<div class="d-flex align-items-center my-3">
			<span class="darker font-weight-600 mr-2" @click="testCalc">
				Seller:
			</span>

			<seller-picker
				class="w-100"
				:reservation="reservation"
				:orignalSeller="reservation.creatorAgent? reservation.creatorAgent : account"
				:agentList="eventPossibleAgentsList(reservation.event)"
				:hideOthers='false'
				:inlcudeWidget='true'
				:hideGetYourGuide='true'
				:hideViator='true'
                :hideAllByChannel="true"
				@input="sellerChanged">
			</seller-picker>
		</div>

		<div v-if="getOrigins.length !== 0" class="custom_grid my-3">
			<div class="darker font-weight-600 mr-2">
				<span class="fs-small bold"><span v-if="originsRequired" style="color: red;">*</span>Origin</span>
			</div>

			<div>
				<v-select 
                    class="w-100"
                    :class="{'reservation__dropdown--error': hasOriginError}"
                    label="name" 
                    :options="originsOptions" 
                    v-model="origin" 
                    :reduce="origin => origin.id" 
                    @input="originChanged">
                </v-select>
			</div>
		</div>

		<div v-if="getSegments.length !== 0" class="custom_grid my-3">
			<div class="darker font-weight-600 mr-2">
				<span class="fs-small bold"><span v-if="segmentsRequired" style="color: red;">*</span>Segment</span>
			</div>

			<div>
				<v-select class="w-100"
					label="name" 
                    :class="{'reservation__dropdown--error': hasSegmentError}"
                    :options="segmentsOptions" 
                    v-model="segment" 
                    :reduce="segment => segment.id" 
                    @input="segmentChanged">
                </v-select>
			</div>
		</div>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { eventMixin } from '@/mixins/event'

    import SellerPicker from '../../../../../tools/SellerPicker'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        mixins: [
            eventMixin
        ],
        data() {
            return {
                selectedAgent: null,
                origin: {
                    name: 'None',
                    id: 0
                },
                segment: {
                    name: 'None',
                    id: 0
                }
            }
        },
        props: {
            reservation: {
                type: Object,
            },
            selectedAgentComissions: {
                type: Object,
                default: null
            }
        },
        created() {
            // Set default seller as me
            this.reservation.creatorUserAccount = this.account;
            this.$set(this.reservation, 'creatorSupplier', this.account.supplier);
            this.reservation.agent = this.agentMe;

            // Set origin
            this.origin.name = !!this.reservation.origin ? this.$set(this.reservation, 'origin', this.origin.name) : this.$set(this.reservation, 'origin', 'None');
            this.origin.id = !!this.reservation.originId ? this.$set(this.reservation, 'originId', this.origin.id) : this.$set(this.reservation, 'originId', null);

            // Set segment
            this.segment.name = !!this.reservation.segment ? this.$set(this.reservation, 'segment', this.segment.name) : this.$set(this.reservation, 'segment', 'None');
            this.segment.id = !!this.reservation.segmentId ? this.$set(this.reservation, 'segmentId', this.segment.id) : this.$set(this.reservation, 'segmentId', null);
        },
        watch: {
            'reservation': {
                handler(newVal, oldVal) {
                    this.$emit('sideBarOriginAndSegmentIsReadyToSubmit', this.isReadyToSubmit)
                },
                deep: true,
                immediate: true,
            },
        },
        computed: {
            ...mapGetters([
                'getAgents',
                'account',
                'getOrigins',
                'getSegments',
                'getCompanySettings'
            ]),
            hasOriginError() {
                return this.originsRequired && !this.reservation.originId;
            },
            hasSegmentError() {
                return this.segmentsRequired && !this.reservation.segmentId;
            },
            isReadyToSubmit() {
                if (this.originsRequired && this.originsOptions.length !== 0 && !this.reservation.originId) return false;
                if (this.segmentsRequired && this.segmentsOptions.length !== 0 && !this.reservation.segmentId) return false;
                
                return true;
            },
            editedAgentList() {
                let agentList = JSON.parse(JSON.stringify(this.getAgents));

                let agentMustHaveName = agentList.filter(agent => {
                    return agent.name != null
                })

                agentMustHaveName.unshift(this.agentMe);

                return agentMustHaveName;
            },
            agentMe() {
                return {brandName: this.account.name + ' (Me)', id: null};
            },
            originsRequired() {
                return this.getCompanySettings.settingsPresets.isOriginRequired;
            },
            segmentsRequired() {
                return this.getCompanySettings.settingsPresets.isSegmentRequired;
            },
            originsOptions() {
                const emptyOrigin = {
                    name: 'None',
                    id: 0
                }
                const origins = this.getOrigins;
                
                // If required, don't allow None selection
                if (this.originsRequired) return origins;
                
                return [emptyOrigin, ...origins];
            },
            segmentsOptions() {
                const emptySegment = {
                    name: 'None',
                    id: 0
                }
                const segments = this.getSegments;

                // If required, don't allow None selection
                if (this.segmentsRequired) return segments; 
                
                return [emptySegment, ...segments];
            }
        },
        methods:{
            ...mapActions([
                'setReservationCalculations',
                'resetCalculationsGuid'
            ]),
            originChanged(origin) {
                this.$set(this.reservation, 'origin', origin.name);
                origin.id === 0 ? this.$set(this.reservation, 'originId', null) : this.$set(this.reservation, 'originId', origin.id);
            },
            segmentChanged(segment) {
                this.$set(this.reservation, 'segment', segment.name);
                segment.id === 0 ? this.$set(this.reservation, 'segmentId', null) : this.$set(this.reservation, 'segmentId', segment.id);
            },
            testCalc() {
                this.setReservationCalculations(this.reservation);
            },
            updateSeller() {
                // DISCONTINUED
                if (this.reservation.agent.id) {
                    // Is agent
                    this.getSelectedUserComissions();
                    this.$set(this.reservation, 'creatorAgent', this.reservation.agent);
                } else {
                    // Is me or my team
                    this.$set(this.reservation, 'creatorAgent', null);
                    this.$set(this.reservation.billing, 'agentCommision', null);
                }

                this.setReservationCalculations(this.reservation);
            },
            sellerChanged(selectedSeller) {
                this.resetCalculationsGuid();
                this.reservation.calculationsGUID = null;

                this.reservation.agent = selectedSeller;

                this.$set(this.reservation, 'currentChannelCommission', {
                    isToOverwriteComponent: false,
                    isToOverwriteProduct: false,
                });

                this.setReservationCalculations(this.reservation).then(response => {
                    const currentChannelCommission = response.data.currentChannelCommission;

                    this.$set(this.reservation, 'currentChannelCommission', currentChannelCommission);
                    this.updateBookingComponents(currentChannelCommission);
                });
            },
            updateBookingComponents({ channelType, channel }) {
                const bookingComponents = this.reservation && this.reservation.bookingComponents;
                
                if (!Array.isArray(bookingComponents)) return;

                bookingComponents.forEach(bookingComponent => {
                    if (!('channelType' in bookingComponent)) {
                        this.$set(bookingComponent, 'channelType', channelType);
                    } else {
                        bookingComponent.channelType = channelType;
                    }

                    if (!('channel' in bookingComponent)) {
                        this.$set(bookingComponent, 'channel', channel);
                    } else {
                        bookingComponent.channel = channel;
                    }
                });
            },
            getSelectedUserComissions() {
                return axios.get('/api/people/GetAgentCommissions', {
                    params: {
                        supplierId: this.account.supplierId,
                        agentId: this.reservation.agent.id
                    }
                }).then(response => {
                    return response
                    if (response.status && response.status == 200) {
                        this.setAgentCommision(response.data);
                    }
                })
            },
            setAgentCommision(commisions) {
                let agentCommision = commisions.defaultCommision;

                for (let commisionRelation of commisions.commissionRelations) {
                    if (commisionRelation.productId == this.reservation.product.id) {
                        agentCommision = commisionRelation.commissionValue;
                    }
                }

                this.$set(this.reservation.billing, 'agentCommision', agentCommision);
            }
        },
        components:{
            vSelect: extendedVSelect,
            SellerPicker
        }
    }
</script>

<style lang="scss" scoped>
    .custom_grid {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-template-rows: 1fr;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        align-items: center;
    }
</style>

<style lang="scss">
    .dropdown.v-select.reservation__dropdown--error {
        .dropdown-toggle {
            border: 1px solid #e73f47;
        }
    }
</style>



// WEBPACK FOOTER //
// AgentSelector.vue?07f17c0a